<template>
    <!-- <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Profile
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <update-profile-information-form
                            :name="$page.props.user.name"
                            :email="$page.props.user.email" />

                <jet-section-border />

                <update-password-form class="mt-10 sm:mt-0" />

                <div v-if="$page.props.jetstream.canManageTwoFactorAuthentication">
                    <jet-section-border />

                    <two-factor-authentication-form class="mt-10 sm:mt-0" />
                </div>

                <jet-section-border />

                <logout-other-browser-sessions-form :sessions="sessions" class="mt-10 sm:mt-0" />

                <jet-section-border />

                <delete-user-form class="mt-10 sm:mt-0" />
            </div>
        </div>
    </app-layout> -->
    <div class="profile">
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">{{ $page.props.lang.profile || "Profile" }}</h2>
            </div>
        </div>
        <div class="update-password">
            <h4 class="title">{{ $page.props.lang.updatePassword || "Update password" }} </h4>
            <p class="desc">{{ $page.props.lang.updatePasswordDescsription || "Ensure your account is using a long, random password to stay secure." }}</p>
            
            <div class="field-group">
                <p class="label">{{ $page.props.lang.currentPassword || "Current password" }}</p>
                <v-text-field  type="password" v-model="form.current_password"
                background-color="#FFFFFF" solo outlined flat dense
                :error-messages="responseErrors.current_password" @focus="responseErrors.current_password=''"></v-text-field>
            </div>
            <div class="field-group">
                <p class="label">{{ $page.props.lang.newPassword || "New password" }}</p>
                <v-text-field  type="password" v-model="form.password"
                background-color="#FFFFFF" solo outlined flat dense
                :error-messages="responseErrors.password" @focus="responseErrors.password=''"></v-text-field>
            </div>
            <div class="field-group">
                <p class="label">{{ $page.props.lang.confirmPassword || "Confirm password" }}</p>
                <v-text-field  type="password" v-model="form.password_confirmation"
                background-color="#FFFFFF" solo outlined flat dense
                :error-messages="responseErrors.password_confirmation" @focus="responseErrors.password_confirmation=''"></v-text-field>
            </div>
            
            <v-btn @click="updatePassword" :loading="updating" color="primary">{{ $page.props.lang.updatePasswordButton || "Update"}}</v-btn>
        </div>
        <div class="two-factor-auth">
            <h4 class="title">{{ $page.props.lang.twoFactorAuth || "Two Factor Authentication"}}</h4>
            <p class="desc">{{ $page.props.lang.twoFactorAuthDescription || "Add additional security to your account using two factor authentication."}}</p>

            <div>
                <h4 v-if="twoFactorEnabled" class="status-info">{{ $page.props.lang.twoFactorAuthEnabled || "You have enabled two factor authentication."}}</h4>
                <h4 v-else>{{ $page.props.lang.twoFactorAuthNotEnabled || "You have not enabled two factor authentication."}}</h4>
                <div>
                    <p>{{ $page.props.lang.twoFactorAuthNotEnabledDescription || "When two factor authentication is enabled, you will be prompted for a secure, random token during authentication. You may retrieve this token from your phone's Google Authenticator application."}}</p>
                </div>
            </div>
            
            <div v-if="twoFactorEnabled">
                <div v-if="qrCode">
                    <div>
                        <p>{{ $page.props.lang.twoFactorAuthNotEnabledScan || "Two factor authentication is now enabled. Scan the following QR code using your phone's authenticator application."}}</p>
                    </div>

                    <div v-html="qrCode">
                    </div>
                </div>

                <div v-if="recoveryCodes.length > 0">
                    <div>
                        <p>{{ $page.props.lang.twoFactorAuthRecoveryCodes || "Store these recovery codes in a secure password manager. They can be used to recover access to your account if your two factor authentication device is lost."}}</p>
                    </div>

                    <div>
                        <p v-for="code in recoveryCodes" :key="code">
                            {{ code }}
                        </p>
                    </div>
                </div>
            </div>

            <div class="buttons">
                <div v-if="!twoFactorEnabled">
                    <v-btn 
                    type="button" 
                    @click.native="enableTwoFactorAuthentication"
                    :class="{ 'opacity-25': enabling }" color="primary"
                    :disabled="enabling">
                        {{ $page.props.lang.enable || "Enable"}}
                    </v-btn>
                </div>

                <div v-else>
                    <v-btn class="mr-3"
                    @click.native="regenerateRecoveryCodes"
                    v-if="recoveryCodes.length > 0">
                        {{ $page.props.lang.regenerateRecoveryCodes || "Regenerate Recovery Codes"}}
                    </v-btn>

                    <v-btn class="mr-3"
                    @click.native="showRecoveryCodes"
                    v-else>
                        {{ $page.props.lang.showRecoveryCodes || "Show Recovery Codes"}}
                    </v-btn>

                    <v-btn @click.native="disableTwoFactorAuthentication"
                    :class="{ 'opacity-25': disabling }" color="primary"
                    :disabled="disabling">
                        {{ $page.props.lang.disable || "Disable"}}
                    </v-btn>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import AppLayout from './../../Layouts/AppLayout'
import DeleteUserForm from './DeleteUserForm'
import JetSectionBorder from './../../Jetstream/SectionBorder'
import LogoutOtherBrowserSessionsForm from './LogoutOtherBrowserSessionsForm'
import TwoFactorAuthenticationForm from './TwoFactorAuthenticationForm'
import UpdatePasswordForm from './UpdatePasswordForm'
import UpdateProfileInformationForm from './UpdateProfileInformationForm'
import EventBus from '@/js/eventbus'

export default {
    props: ['sessions'],
    components: {
        AppLayout,
        DeleteUserForm,
        JetSectionBorder,
        LogoutOtherBrowserSessionsForm,
        TwoFactorAuthenticationForm,
        UpdatePasswordForm,
        UpdateProfileInformationForm,
    },
    layout: AppLayout,
    data() {
        return {
            form: this.$inertia.form({
                current_password: '',
                password: '',
                password_confirmation: '',
            }),
            updating: false,
            enabling: false,
            disabling: false,

            qrCode: null,
            recoveryCodes: [],
            responseErrors: {}
        }
    },
    computed: {
        twoFactorEnabled() {
            return ! this.enabling && this.$page.props.user.two_factor_enabled
            // return false
        }
    },
    methods: {
        updatePassword() {
            this.updating = true
            axios.post('/users/reset_password', this.form)
                .then(response => {
                    if (response.data.status==='OK') {
                        EventBus.$emit('SHOW_NOTIFICATION', {
                            message: response.data.message,
                            color: 'success',
                            timeout: 5000
                        })
                    } else {
                        EventBus.$emit('SHOW_NOTIFICATION', {
                            message: response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    }
                    this.form.reset()
                })
                .catch(error => {
                    this.responseErrors = error.response.data.errors
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                })
                .then(() => {
                    this.updating = false
                })
        },
        enableTwoFactorAuthentication() {
            this.enabling = true

            this.$inertia.post('/user/two-factor-authentication', {}, {
                preserveScroll: true,
            }).then(() => {
                return Promise.all([
                    this.showQrCode(),
                    this.showRecoveryCodes()
                ])
            }).then(() => {
                this.enabling = false
            })
        },
        showQrCode() {
            return axios.get('/user/two-factor-qr-code')
                    .then(response => {
                        this.qrCode = response.data.svg
                    })
        },
        showRecoveryCodes() {
            return axios.get('/user/two-factor-recovery-codes')
                    .then(response => {
                        this.recoveryCodes = response.data
                    })
        },
        regenerateRecoveryCodes() {
            axios.post('/user/two-factor-recovery-codes')
                    .then(response => {
                        this.showRecoveryCodes()
                    })
        },
        disableTwoFactorAuthentication() {
            this.disabling = true

            this.$inertia.delete('/user/two-factor-authentication', {
                preserveScroll: true,
            }).then(() => {
                this.disabling = false
            })
        }
    }
}
</script>
